module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"selectAll":"Hepsini Seç","selectLocation":"Lokasyon Seçin"},"en":{"selectAll":"Select All","selectLocation":"Select Location"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/SiteMultiSelectTree.vue
// module id = TGAJ
// module chunks = 1